'use strict';

var FlightSeasonChartFilterFactory = function FlightSeasonChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightDateRangeFilterFactory', 'FlightLegFilterFactory', 'FlightCabinFilterFactory', 'FlightDOWFilterFactory', 'FlightLevelFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FlightSeasonChartFilter() {
    DemandFilter.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'thematic-flight-chart-season');
    this.registerFilters(injectedFilters);
  }
  FlightSeasonChartFilter.prototype = Object.create(DemandFilter.prototype);
  FlightSeasonChartFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  return FlightSeasonChartFilter;
};
FlightSeasonChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FlightSeasonChartFilterFactory;